import ICommand from '../../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../../FrontApplet/FrontApplet';
import {
	ManagementRemoteControlDisableRequest,
	ManagementRemoteControlDisableResult,
	ManagementRemoteControlEnableRequest,
	ManagementRemoteControlEnableResult,
	ManagementRemoteControlIsEnabledRequest,
	ManagementRemoteControlIsEnabledResult,
	ManagementRemoteControlIsLockedRequest,
	ManagementRemoteControlIsLockedResult,
	ManagementRemoteControlLockRequest,
	ManagementRemoteControlLockResult,
	ManagementRemoteControlRequests,
	ManagementRemoteControlUnlockRequest,
	ManagementRemoteControlUnlockResult,
} from './remoteControlCommands';

export function handleManagementRemoteControlRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<ManagementRemoteControlRequests>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<ManagementRemoteControlRequests>) => {
		switch (commandEvent.command.type) {
			case ManagementRemoteControlEnableRequest:
				await frontApplet.management.remoteControl.enable();
				await dispatch<ManagementRemoteControlEnableResult>({
					type: ManagementRemoteControlEnableResult,
					result: {},
				});
				break;
			case ManagementRemoteControlDisableRequest:
				await frontApplet.management.remoteControl.disable();
				await dispatch<ManagementRemoteControlDisableResult>({
					type: ManagementRemoteControlDisableResult,
					result: {},
				});
				break;
			case ManagementRemoteControlIsEnabledRequest:
				await dispatch<ManagementRemoteControlIsEnabledResult>({
					type: ManagementRemoteControlIsEnabledResult,
					result: await frontApplet.management.remoteControl.isEnabled(),
				});
				break;
			case ManagementRemoteControlLockRequest:
				await frontApplet.management.remoteControl.lock();
				await dispatch<ManagementRemoteControlLockResult>({
					type: ManagementRemoteControlLockResult,
					result: {},
				});
				break;
			case ManagementRemoteControlUnlockRequest:
				await frontApplet.management.remoteControl.unlock();
				await dispatch<ManagementRemoteControlUnlockResult>({
					type: ManagementRemoteControlUnlockResult,
					result: {},
				});
				break;
			case ManagementRemoteControlIsLockedRequest:
				await dispatch<ManagementRemoteControlIsLockedResult>({
					type: ManagementRemoteControlIsLockedResult,
					result: await frontApplet.management.remoteControl.isLocked(),
				});
				break;
			default:
		}
	});
}
